import React, { Component } from 'react';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import PropTypes from 'prop-types';
import { stringify } from 'querystring';
import Spinner from '../common/spinner';
import { sendAnalyticsEvent } from '../../utils/analytics';
import {omit} from 'lodash';

export default class MoreProductsButton extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      numClicks: 0,
      page: Number(this.context.location.query.page) || 1
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleClick = (event) => {
    event.preventDefault();
    if (this.props.api.fetchStatus !== 'notFetching') {
      return;
    }
    sendAnalyticsEvent(
      'Shopping',
      'More Products Button',
      this.state.numClicks + 1
    );

    const { fetchFoundryResponse } = this.props;
    const apiUrl = this.nextPageURL({ json: true });

    fetchFoundryResponse(apiUrl, 'moreContent')
      .then(() => {
        /*
         * On successful API response, increment 'page' and 'numClicks'.
         * On error API response, increment 'numClicks' only.
         */
        const newPage = !this.props.api.hasErrors
          ? this.state.page + 1
          : this.state.page;
        if (this._isMounted) {
          this.setState({
            numClicks: this.state.numClicks + 1,
            page: newPage
          });
        }
      });
  }

  nextPageURL = (newQueryParams = {}) => {
    const { query, pathname } = this.context.location;

    const queryString = stringify({
      ...omit(query, 'page'),
      ...newQueryParams,
      page: this.state.page + 1
    });

    return pathname + '?' + queryString;
  }

  render() {
    const { api } = this.props;
    if (api.fetchStatus === 'moreContent') {
      return <Spinner inline />;
    }

    return (
      <div className="row">
        <a href={this.nextPageURL()}
          id="more-products"
          onClick={this.handleClick}
        >
          <button className="pill pink">
            {
              api.hasErrors
                ? (
                  <RosettaFormattedMessage parentFilename={__filename}
                    id="more_products_button_retry"
                    description='Retry text for "More Products" button'
                    defaultMessage="Try Again?"
                  />
                )
                : (
                  <RosettaFormattedMessage parentFilename={__filename}
                    id="more_products_button"
                    description='Button for "More Products"'
                    defaultMessage="More Products"
                  />
                )
            }
          </button>
        </a>
        {
          api.hasErrors &&
          (
            <div className="alert">
              <RosettaFormattedMessage parentFilename={__filename}
                id="more_products_error_message"
                description="Error message for product list"
                defaultMessage="Oh noes! There was an error loading content"
              />
            </div>
          )
        }
      </div>
    );
  }
}

MoreProductsButton.propTypes = {
  api: PropTypes.shape({
    fetchStatus: PropTypes.string.isRequired,
    hasErrors: PropTypes.bool.isRequired
  }).isRequired,
  fetchFoundryResponse: PropTypes.func.isRequired
};

MoreProductsButton.contextTypes = {
  location: PropTypes.object
};
